import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { useForm } from 'react-hook-form'
import ResearchFrom from './ResearchFrom'
import {
  callIntellectualProperty,
  deleteIntellectualPropertyAttacthment,
  downIntellectualPropertyAttacthment,
  getDownloadFilePath,
  SaveResearch,
} from '../../redux/actions/intellectualProperty'
import { DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import ResearchView from './ResearchView'

export default function ResearchWidgets(props) {
  const [formSchema, setFormSchema] = useState(props.schema)
  const [formValues, setFormValues] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isOnSuccess, setIsOnSuccess] = useState(false)

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    const countValues = formSchema?.values?.length || 0

    let newArr = []
    if (countValues > 0) {
      console.log('> 0')
      setFormValues(formSchema?.values)

      formSchema?.values.map((item, index) => {
        // console.log('item ====> ', item)
        // newArr.push(item.nameOfResearcher)
        newArr.push(item.nameOfResearcher)
      })
    } else {
      console.log('< 0')
      setFormValues(null)
      newArr.push('')
    }

    // setNameOfResearcher(newArr)
  }, [])

  const onSubmitData = (data) => {
    console.log('onSubmit => ', data)

    // return false
    // console.log('value item  => ', itemValue)
    let completeEditionFile = formSchema?.values?.find(
      ({ id }) => id === data?.id
    )?.completeEditionAttachFiles
    // console.log('x => ', completeEditionFile)

    // return false
    const formData = new FormData()

    formData.append('Id', data?.id || '')
    formData.append('ProgressId', data?.progressId || '')
    formData.append('NameTh', data?.nameTh || '')
    formData.append('NameEng', data?.nameEng || '')

    data.issue &&
      data.issue?.forEach((element) => {
        formData.append('Issue', element)
      })
    formData.append('OtherIssue', data?.otherIssue || '')

    data.target &&
      data.target?.forEach((element) => {
        formData.append('Target', element)
      })
    formData.append('OtherTarget', data?.otherTarget || '')

    formData.append('Benefit', data?.benefit || '')

    data.nameOfResearcher &&
      data.nameOfResearcher?.forEach((element) => {
        formData.append('NameOfResearcher', element)
      })

    formData.append('YearOfDevelopment', data?.yearOfDevelopment || '')
    formData.append('Description', data?.description || '')
    formData.append('FullDescription', data?.fullDescription || '')
    formData.append('PaperResult', data?.paperResult || '')

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.completeEditionAttachFiles &&
      data.completeEditionAttachFiles?.forEach((element) => {
        formData.append('CompleteEditionAttachFiles', element.blobFile)
      })
    formData.append('CompleteEditionAttachPathFiles', completeEditionFile || '')

    formData.append('FullName', data?.fullName || '')
    formData.append('Email', data?.email || '')
    formData.append('Telephone', data?.telephone || '')
    formData.append('Agency', data?.agency || '')
    formData.append('Objective', data?.objective || '')

    formData.append('Criteria1', data?.criteria1 ? parseInt(data?.criteria1) : 0)
    formData.append('Criteria2', data?.criteria2 ? parseInt(data?.criteria2) : 0)
    formData.append('Criteria3', data?.criteria3 ? parseInt(data?.criteria3) : 0)

    handleSaveResearch(formData, data?.id)
  }

  const handleSaveResearch = async (request, id) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      let response = await SaveResearch(request, projectId)
      console.log('resssss => ', response)

      if (response) {
        setIsOnSuccess(true)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        setFormValues(response.form.research.values)

        !id && location.reload()
      }
    } catch (error) {
      console.log('error', error)
    }

    setTimeout(() => {
      setIsOnSuccess(false)
    }, 1000)
    setIsLoading(false)
    doneLoading()
  }

  const handlePreviewFile = async (fileObj) => {
    console.log('file => ', fileObj)
    // return false
    startLoading()
    setIsLoading(true)
    try {
      var file = await downIntellectualPropertyAttacthment(fileObj?.id)
      var fileName = fileObj?.name || fileObj?.id

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDownloadFile = async (fileObj) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await downIntellectualPropertyAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDeleteFile = async (fileObj, innovationId) => {
    console.log('handleDeleteFile => ', fileObj)
    // return false
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      let response = await deleteIntellectualPropertyAttacthment(
        projectId,
        innovationId,
        fileObj.id,
        '2'
      )
      console.log('resssss => ', response)
      if (response) {
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
        })
        setIsOnSuccess(true)
        setFormValues(response.form.research.values)
      }
    } catch (error) {
      console.log('error', error)
    }

    setTimeout(() => setIsOnSuccess(false), 1000)
    setIsLoading(false)
    doneLoading()
  }

  const handlePreviewFilePath = async (fileObj) => {
    console.log('file => ', fileObj)
    // return false
    startLoading()
    setIsLoading(true)
    try {
      var file = await getDownloadFilePath(fileObj)
      console.log('file => ', file)
      var fileName = fileObj

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDownloadFilePath = async (fileObj) => {
    setIsLoading(true)
    startLoading()
    try {
      var file = await getDownloadFilePath(fileObj)
      var fileName = fileObj

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleReLoadData = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await callIntellectualProperty(projectId)
      console.log('handleGetSchema => ', _schema.form?.research)
      // setSchema(_schema)
      setFormValues(_schema.form.research.values)
    } catch (error) {
      console.log('error => ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      {formValues?.length > 0 && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={formSchema.header}
          bordered
          style={{ marginBottom: 10 }}
        >
          {formValues.map((item, index) => {
            if (item.disabled) {
              return (
                <>
                  <ResearchView
                    schema={formSchema}
                    index={index}
                    itemValue={item}
                    onSubmit={onSubmitData}
                    onPreview={handlePreviewFile}
                    onDownload={handleDownloadFile}
                    // onDelete={handleDeleteFile}
                    onPreviewFilePath={handlePreviewFilePath}
                    onDownloadFilePath={handleDownloadFilePath}
                    isSuccess={isOnSuccess}
                  />
                </>
              )
            } else {
              return (
                <>
                  <ResearchFrom
                    schema={formSchema}
                    index={index}
                    itemValue={item}
                    onSubmit={onSubmitData}
                    onPreview={handlePreviewFile}
                    onDownload={handleDownloadFile}
                    onDelete={handleDeleteFile}
                    onPreviewFilePath={handlePreviewFilePath}
                    onDownloadFilePath={handleDownloadFilePath}
                    isSuccess={isOnSuccess}
                  />
                </>
              )
            }
          })}
        </Panel>
      )}
    </>
  )
}
